import React, { useEffect, useState } from "react";
import ST from './ST.mp4';
import SerieList from "./lists/SerieList";
import SerieBack from "./back/SerieBack";

function Series() {
    return (
        <section className="section_l">
            <div className="container_news">
                <h3 className="categorie">Séries</h3>
                <div className="back">
                    <SerieBack />
                </div>
                <SerieList />
            </div>
        </section>
    )
}

export default Series;